import type {Configuration} from '../configuration';
import type {AxiosInstance, AxiosPromise, RawAxiosRequestConfig} from 'axios';
import {BASE_PATH, BaseAPI, operationServerMap, RequestArgs} from '../base';
import globalAxios from 'axios';
import {
  assertParamExists,
  createRequestFunction,
  DUMMY_BASE_URL,
  IdRsp,
  serializeDataIfNeeded,
  setSearchParams,
  toPathString,
} from '../common';
import {PinCodeUpdateReq, Room, RoomCreateReq, RoomUpdateReq, Rooms} from '../types/room';

/**
 * RoomServiceApi - axios parameter creator
 * @export
 */
export const RoomServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     * 房间创建
     * @summary 房间创建
     * @param {RoomCreateReq} roomCreateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roomServiceCreate: async (
      roomCreateReq: RoomCreateReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'roomCreateReq' is not null or undefined
      assertParamExists('roomServiceCreate', 'roomCreateReq', roomCreateReq);
      const localVarPath = `/room/room`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        roomCreateReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 房间删除
     * @summary 房间删除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roomServiceDelete: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('roomServiceDelete', 'id', id);
      const localVarPath = `/room/room/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'DELETE', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 房间详情
     * @summary 房间详情
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roomServiceDetail: async (
      id: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('roomServiceDetail', 'id', id);
      const localVarPath = `/room/room/{id}`.replace(`{${'id'}}`, encodeURIComponent(String(id)));
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 房间查询
     * @summary 房间查询
     * @param {string} [buildingId]
     * @param {Array<string>} [ids]
     * @param {number} [pageSize] 当前分页大小
     * @param {number} [pageNum] 当前页数
     * @param {string} [userId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roomServiceFind: async (
      buildingId?: string,
      ids?: Array<string>,
      pageSize?: number,
      pageNum?: number,
      userId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      const localVarPath = `/room/rooms`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (buildingId !== undefined) {
        localVarQueryParameter['buildingId'] = buildingId;
      }

      if (ids) {
        localVarQueryParameter['ids'] = ids;
      }

      if (pageSize !== undefined) {
        localVarQueryParameter['page.size'] = pageSize;
      }

      if (pageNum !== undefined) {
        localVarQueryParameter['page.num'] = pageNum;
      }

      if (userId !== undefined) {
        localVarQueryParameter['userId'] = userId;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 房间修改 pin code
     * @summary 房间修改 pin code
     * @param {string} id
     * @param {PinCodeUpdateReq} pinCodeUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roomServicePinCodeUpdate: async (
      id: string,
      pinCodeUpdateReq: PinCodeUpdateReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'id' is not null or undefined
      assertParamExists('roomServicePinCodeUpdate', 'id', id);
      // verify required parameter 'pinCodeUpdateReq' is not null or undefined
      assertParamExists('roomServicePinCodeUpdate', 'pinCodeUpdateReq', pinCodeUpdateReq);
      const localVarPath = `/room/room/{id}/pin_code`.replace(
        `{${'id'}}`,
        encodeURIComponent(String(id))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PATCH', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        pinCodeUpdateReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     * 房间修改
     * @summary 房间修改
     * @param {string} roomId
     * @param {RoomUpdateReq} roomUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roomServiceUpdate: async (
      roomId: string,
      roomUpdateReq: RoomUpdateReq,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'roomId' is not null or undefined
      assertParamExists('roomServiceUpdate', 'roomId', roomId);
      // verify required parameter 'roomUpdateReq' is not null or undefined
      assertParamExists('roomServiceUpdate', 'roomUpdateReq', roomUpdateReq);
      const localVarPath = `/room/room/{roomId}`.replace(
        `{${'roomId'}}`,
        encodeURIComponent(String(roomId))
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        roomUpdateReq,
        localVarRequestOptions,
        configuration
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * RoomServiceApi - functional programming interface
 * @export
 */
export const RoomServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = RoomServiceApiAxiosParamCreator(configuration);
  return {
    /**
     * 房间创建
     * @summary 房间创建
     * @param {RoomCreateReq} roomCreateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async roomServiceCreate(
      roomCreateReq: RoomCreateReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdRsp>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.roomServiceCreate(
        roomCreateReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RoomServiceApi.roomServiceCreate']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 房间删除
     * @summary 房间删除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async roomServiceDelete(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.roomServiceDelete(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RoomServiceApi.roomServiceDelete']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 房间详情
     * @summary 房间详情
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async roomServiceDetail(
      id: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Room>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.roomServiceDetail(id, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RoomServiceApi.roomServiceDetail']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 房间查询
     * @summary 房间查询
     * @param {string} [buildingId]
     * @param {Array<string>} [ids]
     * @param {number} [pageSize] 当前分页大小
     * @param {number} [pageNum] 当前页数
     * @param {string} [userId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async roomServiceFind(
      buildingId?: string,
      ids?: Array<string>,
      pageSize?: number,
      pageNum?: number,
      userId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Rooms>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.roomServiceFind(
        buildingId,
        ids,
        pageSize,
        pageNum,
        userId,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RoomServiceApi.roomServiceFind']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 房间修改 pin code
     * @summary 房间修改 pin code
     * @param {string} id
     * @param {PinCodeUpdateReq} pinCodeUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async roomServicePinCodeUpdate(
      id: string,
      pinCodeUpdateReq: PinCodeUpdateReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.roomServicePinCodeUpdate(
        id,
        pinCodeUpdateReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RoomServiceApi.roomServicePinCodeUpdate']?.[
          localVarOperationServerIndex
        ]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     * 房间修改
     * @summary 房间修改
     * @param {string} roomId
     * @param {RoomUpdateReq} roomUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async roomServiceUpdate(
      roomId: string,
      roomUpdateReq: RoomUpdateReq,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.roomServiceUpdate(
        roomId,
        roomUpdateReq,
        options
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['RoomServiceApi.roomServiceUpdate']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * RoomServiceApi - factory interface
 * @export
 */
export const RoomServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = RoomServiceApiFp(configuration);
  return {
    /**
     * 房间创建
     * @summary 房间创建
     * @param {RoomCreateReq} roomCreateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roomServiceCreate(roomCreateReq: RoomCreateReq, options?: any): AxiosPromise<IdRsp> {
      return localVarFp
        .roomServiceCreate(roomCreateReq, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 房间删除
     * @summary 房间删除
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roomServiceDelete(id: string, options?: any): AxiosPromise<void> {
      return localVarFp.roomServiceDelete(id, options).then(request => request(axios, basePath));
    },
    /**
     * 房间详情
     * @summary 房间详情
     * @param {string} id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roomServiceDetail(id: string, options?: any): AxiosPromise<Room> {
      return localVarFp.roomServiceDetail(id, options).then(request => request(axios, basePath));
    },
    /**
     * 房间查询
     * @summary 房间查询
     * @param {string} [buildingId]
     * @param {Array<string>} [ids]
     * @param {number} [pageSize] 当前分页大小
     * @param {number} [pageNum] 当前页数
     * @param {string} [userId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roomServiceFind(
      buildingId?: string,
      ids?: Array<string>,
      pageSize?: number,
      pageNum?: number,
      userId?: string,
      options?: any
    ): AxiosPromise<Rooms> {
      return localVarFp
        .roomServiceFind(buildingId, ids, pageSize, pageNum, userId, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 房间修改 pin code
     * @summary 房间修改 pin code
     * @param {string} id
     * @param {PinCodeUpdateReq} pinCodeUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roomServicePinCodeUpdate(
      id: string,
      pinCodeUpdateReq: PinCodeUpdateReq,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .roomServicePinCodeUpdate(id, pinCodeUpdateReq, options)
        .then(request => request(axios, basePath));
    },
    /**
     * 房间修改
     * @summary 房间修改
     * @param {string} roomId
     * @param {RoomUpdateReq} roomUpdateReq
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    roomServiceUpdate(
      roomId: string,
      roomUpdateReq: RoomUpdateReq,
      options?: any
    ): AxiosPromise<void> {
      return localVarFp
        .roomServiceUpdate(roomId, roomUpdateReq, options)
        .then(request => request(axios, basePath));
    },
  };
};

/**
 * RoomServiceApi - object-oriented interface
 * @export
 * @class RoomServiceApi
 * @extends {BaseAPI}
 */
export class RoomServiceApi extends BaseAPI {
  /**
   * 房间创建
   * @summary 房间创建
   * @param {RoomCreateReq} roomCreateReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RoomServiceApi
   */
  public roomServiceCreate(roomCreateReq: RoomCreateReq, options?: RawAxiosRequestConfig) {
    return RoomServiceApiFp(this.configuration)
      .roomServiceCreate(roomCreateReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 房间删除
   * @summary 房间删除
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RoomServiceApi
   */
  public roomServiceDelete(id: string, options?: RawAxiosRequestConfig) {
    return RoomServiceApiFp(this.configuration)
      .roomServiceDelete(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 房间详情
   * @summary 房间详情
   * @param {string} id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RoomServiceApi
   */
  public roomServiceDetail(id: string, options?: RawAxiosRequestConfig) {
    return RoomServiceApiFp(this.configuration)
      .roomServiceDetail(id, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 房间查询
   * @summary 房间查询
   * @param {string} [buildingId]
   * @param {Array<string>} [ids]
   * @param {number} [pageSize] 当前分页大小
   * @param {number} [pageNum] 当前页数
   * @param {string} [userId]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RoomServiceApi
   */
  public roomServiceFind(
    buildingId?: string,
    ids?: Array<string>,
    pageSize?: number,
    pageNum?: number,
    userId?: string,
    options?: RawAxiosRequestConfig
  ) {
    return RoomServiceApiFp(this.configuration)
      .roomServiceFind(buildingId, ids, pageSize, pageNum, userId, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 房间修改 pin code
   * @summary 房间修改 pin code
   * @param {string} id
   * @param {PinCodeUpdateReq} pinCodeUpdateReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RoomServiceApi
   */
  public roomServicePinCodeUpdate(
    id: string,
    pinCodeUpdateReq: PinCodeUpdateReq,
    options?: RawAxiosRequestConfig
  ) {
    return RoomServiceApiFp(this.configuration)
      .roomServicePinCodeUpdate(id, pinCodeUpdateReq, options)
      .then(request => request(this.axios, this.basePath));
  }

  /**
   * 房间修改
   * @summary 房间修改
   * @param {string} roomId
   * @param {RoomUpdateReq} roomUpdateReq
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof RoomServiceApi
   */
  public roomServiceUpdate(
    roomId: string,
    roomUpdateReq: RoomUpdateReq,
    options?: RawAxiosRequestConfig
  ) {
    return RoomServiceApiFp(this.configuration)
      .roomServiceUpdate(roomId, roomUpdateReq, options)
      .then(request => request(this.axios, this.basePath));
  }
}
